__turbopack_context__.v({
  "actions": "EditUser-module__IUUhVq__actions",
  "container": "EditUser-module__IUUhVq__container",
  "row": "EditUser-module__IUUhVq__row",
  "section": "EditUser-module__IUUhVq__section",
  "toggle": "EditUser-module__IUUhVq__toggle",
  "toggleCheckbox": "EditUser-module__IUUhVq__toggleCheckbox",
  "toggleLabel": "EditUser-module__IUUhVq__toggleLabel",
  "toggleSwitch": "EditUser-module__IUUhVq__toggleSwitch",
});
